import { jsx as m } from "react/jsx-runtime";
import { c as i } from "react/compiler-runtime";
import { TableHead as p } from "@mui/material";
import { forwardRef as s } from "react";
const b = s((l, a) => {
  const e = i(7);
  let o, r;
  e[0] !== l ? ({
    children: o,
    ...r
  } = l, e[0] = l, e[1] = o, e[2] = r) : (o = e[1], r = e[2]);
  let t;
  return e[3] !== o || e[4] !== r || e[5] !== a ? (t = /* @__PURE__ */ m(p, { ref: a, ...r, children: o }), e[3] = o, e[4] = r, e[5] = a, e[6] = t) : t = e[6], t;
});
export {
  b as TableHead
};
